import React, { Component } from 'react'
import PropTypes from 'prop-types'
import WizardFormFirstPage from '../common/WizardFormFirstPage'
import WizardFormSecondPage from '../common/WizardFormSecondPage'
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../../components';
import moment from "moment";
import { createEmailManager, getEmailManagerDetail, editEmailManager } from '../../../../redux/actions/emailManagerActions';
import {renderAlert,clearAlert} from '../../../../redux/actions/alertsActions';

import { getCities } from "../../../../redux/actions/countryCityActions";

let campaignID;
let isLoading=false;
class CustomEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ['Home', 'Email Manager', 'Custom Email'],
      links: ["home",'email-manager/overview','email-manager/customemail'],
      page: 1,
      fetchData: '',
      campaignName: '',
      subject: '',
      customEmailContent: '',
      french_subject: '',
      french_customEmailContent: '',
      show: false,
      alertMessage:'',
      title: 'Custom Email',
      multi_lang: "no",
      citiesList: [],
    }

    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.setData = this.setData.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = () =>{
    campaignID = this.props.match.params.campaignID ? this.props.match.params.campaignID : '';
    if (campaignID !== '')
    {
      // isLoading="true";
      this.props.getEmailManagerDetail(campaignID); 
    }
  }

  componentWillMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.handlePageChange();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){ 
      this.setState({
        enable_secondstreet: siteData.enable_secondstreet,
        enable_postup: siteData.postup,
        multi_lang: siteData.multi_lang,
      }); 
    }
    this.props.getCities();
  }

  componentWillReceiveProps(nextProps){

    if (this.props.activecities !== nextProps.activecities && nextProps.activecities) {
      this.setState({ citiesList: nextProps.activecities });
    }

    if(this.props.emailData != nextProps.emailData){
      if(nextProps.emailData){
        let data = nextProps.emailData.data;
        this.setState({
          campaignName: data.campaignName,
          subject: data.subject,
          customEmailContent: data.customEmailContent,
          french_subject: data.french_subject,
          french_customEmailContent: data.french_customEmailContent,
          campaignCityID: data.campCityID,
        });
      }
      isLoading = false;
    }
    
    if(this.props.emailStatus !== nextProps.emailStatus){
      if(nextProps.emailStatus){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('success', nextProps.emailStatus.message);
        this.setState({page: 1})
        this.state.emailType = '';
        this.state.campaignName = '';
        this.state.subject = '';
        this.state.customEmailContent = '';
        this.state.french_subject = '';
        this.state.french_customEmailContent = '';
        this.state.scheduleOn = '';
        this.state.cities = '';
        this.state.subscriberType = '';
        this.state.subscriberStartDate = '';
        this.state.subscriberEndDate = '';
        this.state.filterPurchase = '';
        this.state.catID = '';
        this.state.cityID = '';
        window.scrollTo(0, 0);
      }
      isLoading = false;
    }

    if(this.props.emailUpdateStatus !== nextProps.emailUpdateStatus){
      if(nextProps.emailUpdateStatus){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('success', nextProps.emailUpdateStatus.message);
        this.setState({page: 1})
        window.scrollTo(0, 0);
      }
      isLoading = false;
    }

    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('warning',nextProps.error);
        window.scrollTo(0, 0);
      }
      isLoading = false;
    } 
    if(nextProps.message){
      this.handleShow();
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      window.scrollTo(0, 0);
      isLoading = false;
    }

  }
  nextPage() {
    this.setState({ page: this.state.page + 1 })
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 })
  }

  setData = (data) => {
    this.setState(data);
  }

  saveData = (data) => {
    this.setState(data); 
    isLoading = true;
    if(campaignID == ''){
      const saveData = {
        emailType: 'customEmail',
        campaignName: this.state.campaignName,
        subject: this.state.subject,
        customEmailContent: this.state.customEmailContent,
        french_subject: (this.state.french_subject) ? this.state.french_subject : '',
        french_customEmailContent: (this.state.french_customEmailContent) ? this.state.french_customEmailContent : '',
        scheduleOn: (data.scheduleDateTime) ? moment(data.scheduleDateTime).format('YYYY-MM-DD HH:mm:ss') : '',
        cities: data.cityID,
        subscriberType: (data.startDateValue == 'all') ? 'all' : 'NotAll',
        subscriberStartDate: (data.startDateRange[0]) ? moment(data.startDateRange[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        subscriberEndDate: (data.startDateRange[1]) ? moment(data.startDateRange[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        filterPurchase: (data.purchases == 'category' || data.purchases == 'merchant' || data.purchases == 'not_purchase') ? 'NotAll' : data.purchases,
        catID: data.catID,
        merchantID: data.merchantID,
        importedFiles: data.subscriberList,
        second_street: this.state.enable_secondstreet,
        post_up: this.state.enable_postup,
        lang: data.lang,
        campaignCityID: this.state.campaignCityID,
      }
      this.props.createEmailManager(saveData);
      isLoading = false;
    }else{
      const updateData = {
        id: campaignID,
        emailType: 'customEmail',
        campaignName: this.state.campaignName,
        subject: this.state.subject,
        customEmailContent: this.state.customEmailContent,
        french_subject: (this.state.french_subject) ? this.state.french_subject : '',
        french_customEmailContent: (this.state.french_customEmailContent) ? this.state.french_customEmailContent : '',
        scheduleOn: (data.scheduleDateTime) ? moment(data.scheduleDateTime).format('YYYY-MM-DD HH:mm:ss') : '',
        cities: data.cityID,
        subscriberType: (data.startDateValue == 'all') ? 'all' : 'NotAll',
        subscriberStartDate: (data.startDateRange[0]) ? moment(data.startDateRange[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        subscriberEndDate: (data.startDateRange[1]) ? moment(data.startDateRange[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        filterPurchase: (data.purchases == 'category' || data.purchases == 'merchant' || data.purchases == 'not_purchase') ? 'NotAll' : data.purchases,
        catID: data.catID,
        merchantID: data.merchantID,
        importedFiles: data.subscriberList,
        second_street: this.state.enable_secondstreet,
        post_up: this.state.enable_postup,
        lang: data.lang,
        campaignCityID: this.state.campaignCityID,
      }
      this.props.editEmailManager(updateData);
      isLoading = false;
    }    
  }

  render() {
    const { onSubmit } = this.props
    const { page } = this.state
    
    return (
      <div className="col-lg-12 add-sub-admin">
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {this.state.show && this.state.alertMessage !=='' &&        
              <div className="col-lg-12">
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </div>
            }
          </div>
        </div>
        {(campaignID != '') ?
        <div>
          {(page === 1 && this.state.campaignName) && 
            <WizardFormFirstPage 
              onSubmit={this.nextPage} 
              onSubmitData={this.setData}
              dataValue={this.state}
              citiesList={this.state.citiesList}
            />
          }
        </div>
        :
        <div>
          {(page === 1) && 
            <WizardFormFirstPage 
              onSubmit={this.nextPage} 
              onSubmitData={this.setData}
              dataValue={this.state}
              dropdown={true}
              citiesList={this.state.citiesList}
            />
          }
        </div>
        }
        
        {page === 2 && (
          <WizardFormSecondPage
            previousPage={this.previousPage}
            onSave={this.saveData}
            onPrevData={this.setData}
            data={this.state}
          />
        )}
      </div>
    )
  }
}

CustomEmail.propTypes = {}

const mapStateToProps = (state,ownProps) => {
    return {
      activecities: state.countryCityReducers.activecities,
      error: state.emailManagerReducer.error,
      emailStatus:  state.emailManagerReducer.emailStatus,
      emailData: state.emailManagerReducer.emailData,
      emailUpdateStatus: state.emailManagerReducer.emailUpdateStatus,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {createEmailManager, getEmailManagerDetail, editEmailManager, renderAlert, clearAlert, getCities})
)(CustomEmail);


// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/custom/CustomEmail.js